import type { AriaLabelingProps } from '../../../core/types/a11y-props.js';

/**
 * Resolves the accessible name of a panel surface: a consumer `aria-label`
 * wins over the built-in one, and an `aria-labelledby` reference suppresses
 * the built-in label so the surface never carries both.
 *
 * @internal
 */
export function resolvePanelLabel(
  domProps: AriaLabelingProps | undefined,
  defaultLabel: string,
): string | undefined {
  if (domProps?.['aria-label'] !== undefined) {
    return domProps['aria-label'];
  }
  return domProps?.['aria-labelledby'] ? undefined : defaultLabel;
}
